(function () {
  var stage = document.getElementById("nn-stage");
  var spin = document.getElementById("nn-spin");
  var disc = document.getElementById("nn-disc");
  if (!stage || !spin || !disc) return;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var speed = parseFloat(stage.dataset.speed || "0.16");
  var spinOn = stage.dataset.spin !== "false";
  var mq = matchMedia("(max-width: 900px)");
  var LANES_DESK = { right: 58, left: -52, center: 0, hide: 0 };
  var CIN = document.documentElement.getAttribute("data-m") !== "swipe";
  var LANES_MOB = CIN ? { right: 20, left: -20, center: 0, hide: 0 } : { right: 8, left: -8, center: 0, hide: 0 };
  var LANES = mq.matches ? LANES_MOB : LANES_DESK;
  var FOLLOW = 12;
  var FOLLOW_BLEND = 7;

  function getY() {
    return (document.scrollingElement || document.documentElement).scrollTop || window.scrollY || 0;
  }

  function keyframes() {
    var y = getY();
    return [].slice.call(document.querySelectorAll("[data-nn-lane]")).map(function (el) {
      var r = el.getBoundingClientRect();
      return {
        mid: y + r.top + r.height / 2,
        lane: (mq.matches && el.dataset.nnLaneM) || el.dataset.nnLane,
        ym: mq.matches && CIN && el.dataset.nnYM ? parseFloat(el.dataset.nnYM) : null,
        sm: mq.matches && CIN && el.dataset.nnScaleM ? parseFloat(el.dataset.nnScaleM) : null,
        scale: parseFloat(el.dataset.nnScale || "0.8"),
        pulse: parseFloat(el.dataset.nnPulse || "0.09"),
        pack: el.dataset.nnPack || "",
        alt: el.dataset.nnPackAlt || "",
      };
    }).sort(function (a, b) { return a.mid - b.mid; });
  }

  var kfs = keyframes();
  var packLayers = {};
  var packOp = {};
  kfs.forEach(function (k) {
    if (!k.pack || packLayers[k.pack]) return;
    var img = document.createElement("img");
    img.className = "nn-pack-layer";
    img.src = k.pack;
    img.alt = k.alt || "";
    img.decoding = "async";
    img.draggable = false;
    spin.appendChild(img);
    packLayers[k.pack] = img;
    packOp[k.pack] = 0;
  });

  var restC = 0;
  function measureRest() { restC = spin.offsetTop + spin.offsetHeight / 2; }
  function yOf(k) { return k.ym == null ? 0 : k.ym * innerHeight - restC; }
  function sOf(k) {
    if (k.sm != null) return k.sm;
    return mq.matches ? Math.min(1.0, Math.max(0.9, k.scale * 0.92)) : k.scale;
  }
  measureRest();
  var resizeTimer;
  function refresh() {
    LANES = mq.matches ? LANES_MOB : LANES_DESK;
    kfs = keyframes();
    measureRest();
  }
  addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refresh, 80);
  }, { passive: true });
  if (mq.addEventListener) mq.addEventListener("change", refresh);
  else mq.addListener(refresh);
  document.addEventListener("shopify:section:load", refresh);
  addEventListener("load", refresh);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);

  function weights(prev, next, e) {
    var w = {};
    var id;
    for (id in packLayers) w[id] = 0;
    if (prev.pack) w[prev.pack] = (w[prev.pack] || 0) + (1 - e);
    if (next.pack) w[next.pack] = (w[next.pack] || 0) + e;
    return w;
  }

  function laneNow() {
    if (!kfs.length) return { x: 0, y: 0, s: 0.8, o: 1, p: 0.09, w: {} };
    var c = getY() + innerHeight * 0.5;
    var prev = kfs[0];
    var next = kfs[kfs.length - 1];
    var i, k;
    for (i = 0; i < kfs.length; i++) {
      k = kfs[i];
      if (k.mid <= c) prev = k;
      if (k.mid > c) { next = k; break; }
      next = k;
    }
    var span = next.mid - prev.mid;
    var t = span === 0 ? 0 : Math.min(Math.max((c - prev.mid) / span, 0), 1);
    var e = t * t * (3 - 2 * t);
    var x1 = LANES[prev.lane] || 0;
    var x2 = LANES[next.lane] || 0;
    var o1 = prev.lane === "hide" ? 0 : 1;
    var o2 = next.lane === "hide" ? 0 : 1;
    return {
      x: x1 + (x2 - x1) * e,
      y: yOf(prev) + (yOf(next) - yOf(prev)) * e,
      s: sOf(prev) + (sOf(next) - sOf(prev)) * e,
      o: o1 + (o2 - o1) * e,
      p: prev.pulse + (next.pulse - prev.pulse) * e,
      w: weights(prev, next, e),
    };
  }

  var L0 = laneNow();
  var cy = L0.y + (L0.y && !reduce ? innerHeight * 0.45 : 0); /* rise-in on load */
  var cx = 0, cs = 0.92, co = 1, crot = 0, cake = 1, cb = 1;
  var rotTarget = 0;
  var lastY = getY();
  var lastT = performance.now();
  var degPerPx = spinOn && !reduce ? speed * 2.6 : 0;
  var lastTx = "";
  var banners = [].slice.call(document.querySelectorAll("[data-nn-banner]"));

  function exp(cur, target, lambda, dt) {
    return cur + (target - cur) * (1 - Math.exp(-lambda * dt));
  }

  function frame(now) {
    var dt = Math.min(0.05, (now - lastT) / 1000);
    lastT = now;
    var y = getY();
    rotTarget += (y - lastY) * degPerPx;
    lastY = y;

    var L = laneNow();
    var targetCake = 1;
    var id, sum = 0;
    for (id in L.w) sum += L.w[id];
    if (sum > 1) {
      for (id in L.w) L.w[id] /= sum;
      sum = 1;
    }
    targetCake = mq.matches && !CIN ? 0 : 1 - sum;

    cx = exp(cx, L.x, FOLLOW, dt);
    cs = exp(cs, L.s, FOLLOW, dt);
    cy = exp(cy, L.y, cy > L.y + 40 ? 4.5 : FOLLOW, dt);
    co = exp(co, L.o, FOLLOW, dt);
    cake = exp(cake, targetCake, FOLLOW_BLEND, dt);
    crot = exp(crot, rotTarget, cake > 0.2 ? FOLLOW : 4, dt);
    var breathe = reduce ? 1 : 1 + (L.p || 0) * Math.sin(y * 0.0068);
    cb = exp(cb, breathe, 10, dt);

    var tx = "translate3d(" + cx.toFixed(2) + "%," + cy.toFixed(1) + "px,0) scale(" + (cs * cb).toFixed(3) + ")";
    if (tx !== lastTx) {
      spin.style.transform = tx;
      lastTx = tx;
    }

    var cakeScale = 0.92 + 0.08 * cake;
    disc.style.opacity = cake.toFixed(3);
    disc.style.transform = "rotate(" + crot.toFixed(2) + "deg) scale(" + cakeScale.toFixed(3) + ")";
    stage.style.opacity = co < 0.995 ? co.toFixed(3) : "1";

    for (id in packLayers) {
      var target = L.w[id] || 0;
      packOp[id] = exp(packOp[id], target, FOLLOW_BLEND, dt);
      var w = packOp[id];
      var img = packLayers[id];
      img.style.opacity = w.toFixed(3);
      var packY = mq.matches && !CIN ? "0" : "-50%";
      img.style.transform =
        "translate3d(0," + packY + ",0) rotate(" + (crot * 0.18 * (1 - w)).toFixed(2) +
        "deg) scale(" + (0.88 + 0.14 * w).toFixed(3) + ")";
    }

    var bi, hero, speed, py;
    for (bi = 0; bi < banners.length; bi++) {
      speed = parseFloat(banners[bi].getAttribute("data-nn-banner") || "0.18");
      if (!speed || reduce) continue;
      hero = banners[bi].closest(".nn-hero");
      if (!hero) continue;
      py = -hero.getBoundingClientRect().top * speed * (mq.matches && !CIN ? 0.35 : 1);
      banners[bi].style.transform = "translate3d(0," + py.toFixed(1) + "px,0)";
    }

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting && e.target.dataset.nnAcc) {
        document.documentElement.style.setProperty("--flav", e.target.dataset.nnAcc);
      }
    });
  }, { rootMargin: "-40% 0px -40% 0px" });
  [].slice.call(document.querySelectorAll("[data-nn-acc]")).forEach(function (el) { io.observe(el); });
})();
